<template>
  <v-dialog
    v-model="dialog"
    :max-width="800"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
      <v-card class="dialog">
        <v-card-title>
          <h2>Neues Feld für Prozesssteckbrief hinzufügen</h2>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-7">
            <v-container>
              <v-row id="rowContainer">
                <v-col>
                  <v-text-field
                  label="Feldname"
                  v-model="newField.name"
                ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-radio-group
                  v-model="newField.fieldType"
                  row
                >
                <template v-slot:label>
                  <div>Feldtyp</div>
                </template>
                  <v-radio
                    v-for="option in fieldType"
                    :key="option.value"
                    :label="option.name"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group>
                </v-col>
              </v-row>
              <v-row  v-if="newField.fieldType == 'NUMBER'" id="rowContainer">
                <v-col>
                  <v-text-field
                  label="Minimum"
                  v-model="newField.minValue"
                  type="number"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                  label="Maximum"
                  v-model="newField.maxValue"
                  type="number"
                ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-radio-group
                  v-model="newField.valueType"
                  row
                >
                <template v-slot:label>
                  <div>Werttyp</div>
                </template>
                  <v-radio
                    v-for="option in valueType"
                    :key="option.value"
                    :label="option.name"
                    :value="option.value"
                  ></v-radio>
                </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-else id="rowContainer">
                <v-text-field
                  label="Optionen"
                  v-model="option"
                  @keydown.enter="(event) => addOption(event)"
                ></v-text-field>
              </v-row>
              <v-row v-if="newField.fieldType == 'NUMBER'" id="rowContainer">
                <v-text-field
                  label="Default Wert"
                  v-model="newField.defaultValue"
                  type="number"
                ></v-text-field>
              </v-row>
              <v-row v-else id="rowContainer">
                <v-select
                    v-model="newField.defaultValue"
                    :items="newField.options"
                    item-text="name"
                    item-value="value"
                    label="Default Wert"
                  ></v-select>
              </v-row>
              <v-row id="rowContainer">
                <v-col>
                  <v-switch
                    v-model="newField.canFilter"
                    label="Feld kann gefiltert werden"
                  ></v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="newField.isDiagram"
                    label="Feld ist im Diagramm verfügbar"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-btn
                color="primary"
                type="submit"
                @click="addField"
              >
                Speichern
              </v-btn>
            </v-container>
        </v-card-text>
    </v-card>


  </v-dialog>
</template>

<script>
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
export default {
  name: "RessourcesDialog",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      option: "",
      options: {
        width: 400,
        zIndex: 200,
      },
      fieldType: [
        {name: "Dropdown", value: "SELECT"},
        {name: "Zahl", value: "NUMBER"}
      ],
      valueType: [
        {name: "Prozent", value: "PERCENT"},
        {name: "Wert", value: "VALUE"}
      ],
      newField: {
        name: null,
        fieldType: null,
        minValue: null,
        maxValue: null,
        valueType: null,
        options: [],
        defaultValue: null,
        canFilter: false,
        isDiagram: false
      }
    }
  },
  methods: {
    resetNewField(){
      this.newField = {
        name: null,
        fieldType: null,
        minValue: null,
        maxValue: null,
        valueType: null,
        options: [],
        defaultValue: null,
        canFilter: false,
        isDiagram: false
      }
    },
    close(){
      this.resetNewField();
      this.dialog = false;
      this.reject();
    },
    addOption(event){
      this.newField.options.push(this.option);
      this.option = null;
    },
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    addField() {
      this.resolve(this.newField);
      this.resetNewField();
      this.dialog = false;
    },
  }
};
</script>

<style>
.dialog {
  flex-grow: 0;
  padding: 20px;
  background-color: #fff;
}

.header{
  width: 100%;
  height: 50px;
  margin: 0px;
}
.description{
  display:inline-block;
  width: calc(60% - 5px);
  height: 400px;
  margin: 15px 5px 0 0;
}
.characteristicsDescription{
  display:inline-block;
  width: 100%;
  height: 400px;
  margin: 15px 5px 0 0;
}
.modelList{
  display:inline-block;
  width: calc(40% - 15px);
  height: 400px;
  margin: 5px 0 0 15px;
  border-left: 2px solid var(--v-primary-base);
}
.elementDivider{

  margin: 1px;
  border: 0.5px solid var(--v-primary-base);
}
</style>